import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-placeholder';

class OrderNumber extends LitEntity {
  static get styles() {
    return sharedStyles;
  }

  render() {
    if (!this.entity) {
      return html`<bn-placeholder></bn-placeholder>`;
    }
    const { orderNumber = '' } = this.entity.properties;
    return html`
      <span title="${orderNumber}">${orderNumber}</span>
    `;
  }
}

window.customElements.define('order-number', OrderNumber);
